import React, { useEffect, useRef, useState } from "react";
import { Typography } from "@shared/ui/Typography";
import { useTranslation } from "next-i18next";
import styled from "styled-components";

interface IProps {
  sendCode: () => void;
  className?: string;
}

export function CodeTimer({ sendCode, className }: IProps) {
  const { t } = useTranslation();
  const interval = useRef<number>(null);
  const [isSendAgainMessage, setIsSendAgainMessage] = useState(true);
  const [codeCounter, setCodeCounter] = useState(59);

  useEffect(() => {
    if (isSendAgainMessage) {
      const tick = () => {
        setCodeCounter((prevSeconds) => prevSeconds - 1);
      };
      interval.current = window.setInterval(() => tick(), 1000);
    }
  }, [codeCounter, isSendAgainMessage]);

  useEffect(() => {
    if (codeCounter === 0) {
      clearInterval(interval.current);
      setIsSendAgainMessage(false);
      setCodeCounter(59);
    }

    return () => clearInterval(interval.current);
  }, [codeCounter]);

  const sendCodeAgain = async () => {
    await sendCode();
    setIsSendAgainMessage(true);
  };

  return (
    <StyledText className={className}>
      {isSendAgainMessage ? (
        <Typography>
          {t(`Отправить код повторно можно через 00:{{timer}}`, {
            timer: codeCounter > 9 ? codeCounter : `0${codeCounter}`,
          })}
        </Typography>
      ) : (
        <StyledResend onClick={sendCodeAgain}>
          {t(`Отправить код повторно`)}
        </StyledResend>
      )}
    </StyledText>
  );
}

const StyledText = styled.div`
  display: grid;
  justify-content: center;
`;

const StyledResend = styled(Typography)`
  text-decoration: underline;
  cursor: pointer;
`;
